module.exports = __webpack_public_path__ + "img/imagen-fondo-g.2b29053d.png";